import { useAppSelector } from 'src/app/store/hooks';
import { DataGrid } from 'src/common/DataGrid';

import type { HydratedTripLineItem } from './cells/types';
import { allColumns } from './columns';
import type { InvoiceNestedLineItemWithId } from './InvoiceFormContext';

interface InvoiceLineItemListProps {
  lineItems: InvoiceNestedLineItemWithId[];
  onDeleteLineItem: (rowIndex: number, row: HydratedTripLineItem) => void;
}

export function InvoiceLineItemList({
  lineItems,
  onDeleteLineItem,
}: InvoiceLineItemListProps) {
  const editingLineItemGroup = useAppSelector(
    (state) => state.invoice.editingLineItemGroup
  );

  return (
    <DataGrid
      tableId="invoice-line-item"
      columns={allColumns}
      data={lineItems}
      // Ensure the row updates using the temporary id value (works on both create/edit)
      getRowId={(row) => row.__id}
      includePagination={false}
      headerClassName="bg-slate-100"
      cellClassName="align-top"
      containerClassName="print:max-w-[100vw]"
      isEditingRow={(row) => row.trip.id === editingLineItemGroup}
      enableGridScrolling={false}
      onDeleteRow={(rowIndex, row) => {
        const lineItemToDelete = lineItems.find((item) => item === row);
        if (!lineItemToDelete) {
          return;
        }

        onDeleteLineItem(rowIndex, lineItemToDelete);
      }}
    />
  );
}
